import { setHeader } from "@/util/set-header";
import { DatePicker, ActionSheet, Button, ImagePicker, TextareaItem, Carousel, PickerView, Toast, Calendar } from "antd-mobile";
import React from "react";
import  moment  from "moment";
import './book-info.less'
import { withRouter } from "react-router";
import {StructureList, buildingNoListApi,sanyRoomApi, sanyBedListApi, employeeInfoApi, bookRoomAddApi, uploadImageApi} from "@/api/sany";
import Cookies from "universal-cookie";
import compress from '@/util/image-compress'
import { phonePlatform } from "@/util/util";
// const nowTimeStamp = Date.now();
// const now = new Date(nowTimeStamp);
const cookie = new Cookies()
const extra: any = {
  '2017/07/15': { info: 'Disable', disable: true },
}

const now = new Date()

@(withRouter as any)
export default class BookInfo extends React.Component<any, any> {
  state = {
    tab: 1,
    config: {},
    show: false,
    apply_reason: '',
    openBuildRoomList: false,
    structureValue1: [],
    structureValue2: [],
    structureValue3: [],
    active1: '',
    active2: '',
    active3: '',
    startDate: '',
    endDate: '',
    days: '1',
    defaultStartTime: new Date(+now),
    // defaultEndTime: new Date(+now + 61920000),
    defaultEndTime: new Date(+now + (31536000000)*3),
    defaultStartTime1: '',
    defaultEndTime1: '',
    multiple: false,
    files: [],
    startDay: '',
    endDay: '',
    // 楼栋
    buildNames: '',
    buildId: '',
    // 房间
    roomNames: '',
    roomId: '',
    // 床位
    bed: '',
    bedId:'',
    freeType:'工资划扣',
    payType:1, //工资划扣1，部门划转2
    department:'请选择扣费部门',
    departmentId:'',
    floorList: [],
    roomList: [],
    BedList: [],
    departmentList: [], // 部门划转数据
    showDepartment:false,
    imgHeight: 277.5,
    pickClassName: 'picker-bottom hide',
    pickerValue: [],
  }
  detailInfo: any = {}
  imgArr = []
  userInfo: any = {}
  roomPage = 1
  constructor(prop: any) {
    super(prop)
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
    this.joinRoom = this.joinRoom.bind(this)
    this.submitButton = this.submitButton.bind(this)
    this.submitClick = this.submitClick.bind(this)
    this.payType = this.payType.bind(this)
    this.uploadImg = this.uploadImg.bind(this)
    this.roomImg = this.roomImg.bind(this)
    this.onChangeUploadImg = this.onChangeUploadImg.bind(this)
    this.onAddImageClick = this.onAddImageClick.bind(this)
    this.onImageClick = this.onImageClick.bind(this)
    this.getUserInfo = this.getUserInfo.bind(this)
    this.changeDepart = this.changeDepart.bind(this)
    this.changePay = this.changePay.bind(this)
    this.showBuildRoomList = this.showBuildRoomList.bind(this)
  }
  componentDidMount() {
    setHeader({ title: this.props.location.state&&this.props.location.state.propertyTab === '3' ? '申请员工宿舍' : '申请招待所', leftToHome: this.goHomePage, leftClick: this.leftClick })
    const obj:any = (sessionStorage.getItem('roomInfo'))
    this.detailInfo = JSON.parse(obj)
    this.getUserInfo()
    this.setState({
      // show: false,
      startDate: this.props.location.state&&this.props.location.state.propertyTab === '3' ? this.date(new Date(+now)) : this.props.location.state.start,
      // endDate: this.date(new Date(+now + 61920000)),
      endDate: this.props.location.state&&this.props.location.state.propertyTab === '3' ? this.date(new Date(+now + (31536000000)*3)) : this.props.location.state.end,
    })
    if(this.detailInfo&&this.detailInfo.image) {
      this.imgArr = this.detailInfo.image
    }
  }
  async getUserInfo(){
    const {data} = await employeeInfoApi({phone:cookie.get('sany_phone'), room_type:this.props.location.state&&this.props.location.state.roomId})
    if (data.code === 'SUCCESS') {
      this.userInfo = data.data
    } else {
      Toast.info(data.msg)
    }
  }
  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      this.props.history.push({
        pathname: '/sany/dorm-list',
      })
    } else {
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('');
      }
    }
  }
  // 选择日期
  onDateSelect = () => {
    this.setState({
      show: true,
      config: {
        // defaultValue: [this.state.defaultStartTime, this.state.defaultEndTime],
        defaultValue: [ this.props.location.state.propertyTab === '3' ? this.state.defaultStartTime : this.state.defaultStartTime1, this.props.location.state.propertyTab === '3' ? this.state.defaultEndTime : this.state.defaultEndTime1],
      },
    })
  }
  // 关闭日历
  onCancel = () => {
    this.setState({
      show: false
    })
  }
  // 确认日期
  onConfirm = (startTime: any, endTime: any) => {
    if (this.date(startTime) === this.date(endTime)) {
      Toast.info('起止日期不能选择同一天，请重新选择入住时间！')
      return
    }
    this.setState(
      {
        show: false,
        startTime,
        endTime,
        startDate: this.date(startTime),
        endDate: this.date(endTime),
        days: this.day(startTime, endTime),
        defaultStartTime: startTime,
        defaultEndTime: endTime,
        defaultStartTime1: startTime,
        defaultEndTime1: endTime,
        totalDays: this.day(startTime, endTime),
      },
      () => {
        // this.getPrice()
      },
    )
  }
  // 日期换成想要的展示
  date(startTime: any) {
    const newDate =
      startTime.getFullYear() +
      '-' +
      (startTime.getMonth() + 1) +
      '-' +
      startTime.getDate()
    return newDate
  }

  // 计算两个日期间的天数
  day(startTime: any, endTime: any) {
    var diff = endTime.getTime() - startTime.getTime() //时间差的毫秒数

    //计算出相差天数
    var days = Math.floor(diff / (24 * 3600 * 1000))
    return days
  }

  getDateExtra = (date: any) => extra[+date]
  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  onAddImageClick(e:any) {
    if(this.state.files.length === 0) {
      this.setState({
        files: []
      })
    }
  }
  onImageClick(index: any, files: any) {
    console.log(index,'index')
    console.log(files,'files')
  }
  // 上传图片
  async onChangeUploadImg(files: any, type: any, index: any) {
    if (type==='remove') {
      this.setState({
        files,
      })
    } else {
      //图片压缩
      compress(
        files[files.length - 1].file,
        {
          compress: {
            width: 1600,
            height: 1600,
            quality: 0.5,
          },
          type: 'file',
        },
        async (resizeFile: any) => {
          let size = Math.round((resizeFile.size * 100) / (1024 * 1024)) / 100 //按MB换算
          //限制大小小于2M
          if (size < 2) {
            let formData = new FormData()
            formData.append('image', files[files.length-1].file)
            formData.append('type', 'user_face')
            Toast.info('图片上传中')
            const { data } = await uploadImageApi(formData)
            Toast.hide()
            if (data.code === 'SUCCESS') {
                let arr:any = this.state.files
                arr.push({url:data.data.url, id:'1'})
                this.setState({
                  files:arr,
                });
            } else {
              Toast.info(data.msg)
            }
          } else {
            Toast.info('文件大小超过系统规定大小')
          }
        },
      )
    }
  }
  // 房间图片和简介
  roomImg() {
    const imgW = window.screen.width - 20
    // const imgH = (imgW * 3 / 4) + 'px'
    if(this.imgArr&&this.imgArr.length > 0) {
      const arr:any = []
      this.imgArr&&this.imgArr.forEach((v:any)=>{
        arr.push(v.url)
      })
      return (
        <div className="component-body">
          <div className="dorm-info">
                <Carousel
                  autoplay
                  infinite
                >
                  {arr.map((val:any) => (
                    <a
                      key={val}
                      style={{ display: 'inline-block', width: '100%', height: '100%' }}
                    >
                      <img
                        src={val}
                        alt=""
                        style={{ width: '100%',  height:'100%', verticalAlign: 'top',borderRadius: '5px' }}
                        onLoad={() => {
                          // fire window resize event to change height
                          window.dispatchEvent(new Event('resize'));
                        }}
                      />
                    </a>
                  ))}
                </Carousel>
             <div className="between-row dorm-info-mid">
              <div>
                <span style={{ fontSize: '16px' }}>{this.detailInfo.name}</span>
                <span style={{ fontSize: '14px', color: '#888888', marginLeft:'15px' }}>{this.detailInfo.acreage}{this.detailInfo.acreage?'m²':''}</span>
              </div>
              <div>
                <span style={{ fontSize: '14px', color:'#cf6568' }}>{this.detailInfo.property === '3' ? this.detailInfo.month_price : this.detailInfo.day_price}{this.detailInfo.property === '3' ?'元/床/月':'元/天'}</span>
              </div>
            </div>
            <div className="dorm-info-mid" style= {{ borderTop: '1px solid #eeeeee'}}>
              <div style={{ fontSize: '14px', color: '#888888' }}>房间简介：</div>
              <div style={{ fontSize: '14px', color: '#888888', marginTop:'5px' }}>{this.detailInfo.short_desc}</div>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="component-body">
          <div className="dorm-info">
            <div>
              {/* <img src="//s1.axhome.com.cn/homepage/b3/e5/b3e5bb3c6fc92e9038c3e5a84f167615.jpg" alt="" style={{ width: '100%', height: '100%' }} /> */}
              <img src="/public/assets/img/picture.png" alt="" style={{ width: '100%', height: this.state.imgHeight }} />
            </div>
            <div className="between-row dorm-info-mid">
              <div>
                <span style={{ fontSize: '16px' }}>{this.detailInfo.name}</span>
                <span style={{ fontSize: '14px', color: '#888888', marginLeft:'15px' }}>{this.detailInfo.acreage}{this.detailInfo.acreage?'m²':''}</span>
              </div>
              <div>
                <span style={{ fontSize: '14px', color:'#cf6568' }}>{this.detailInfo.property === '3' ? this.detailInfo.month_price : this.detailInfo.day_price}{this.detailInfo.property === '3' ?'元/床/月':'元/天'}</span>
              </div>
            </div>
            <div className="dorm-info-mid" style= {{ borderTop: '1px solid #eeeeee'}} >
              <div style={{ fontSize: '14px', color: '#888888' }}>房间简介：</div>
              <div style={{ fontSize: '14px', color: '#888888', marginTop:'5px' }}>{this.detailInfo.short_desc}</div>
            </div>
          </div>
        </div>
      )
    }
  }
  // 入住房间信息
  joinRoom() {
    const startDay = this.state.startDay === '' ? '请选择日期' : this.state.startDay
    // const minDate = new Date(now) ? new Date(now.getTime() + 24*60*60*1000) : undefined
    const minDate = new Date(now) ? new Date(now) : undefined
    const endDate = sessionStorage.getItem('endTime')
    const maxDate = endDate ? new Date(endDate) : undefined
    return (
      <div className="component-body">
        <div className="dorm-info">
          <div className="dorm-info-title">
            <span style={{ color: '#cf6568', fontSize: '18px'}}>请填写入住房间信息</span>
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{ height: '40px' }}>
              <span style={{ color: '#434343', fontSize: '16px' }}>房型</span>
              <span style={{ color: '#868686', fontSize: '13px' }}>{this.detailInfo.name}</span>
            </div>
            {/* <div className="between-row" style={{ height: '40px' }} onClick={() => this.changeBuildRoom()}>
              {this.detailInfo.property === '1' && sessionStorage.getItem('reservationType') === 'reservation' ? <span style={{ color: '#434343', fontSize: '16px' }}>选择楼栋/房间号</span> : ''}
              {this.detailInfo.property === '3' || sessionStorage.getItem('reservationType') === 'changeBed' ? <span style={{ color: '#434343', fontSize: '16px' }}>选择楼栋/床位号</span> : ''}
              {this.detailInfo.property === '1' && sessionStorage.getItem('reservationType') === 'reservation'? <span  style={{ color: '#868686', fontSize: '13px' }}>{this.state.buildNames + ' >' + this.state.roomNames}</span> 
              : this.detailInfo.property === '3' || sessionStorage.getItem('reservationType') === 'changeBed'? 
              <span  style={{ color: '#868686', fontSize: '13px' }}>{this.state.bed ? this.state.buildNames + ' >' + this.state.roomNames + ' >' + this.state.bed : '>'}</span> : null
               }
            </div> */}
            {(this.detailInfo.property === '3' && (sessionStorage.getItem('reservationType') === 'reservation') || (sessionStorage.getItem('reservationType') === 'changeBed')) && (
              <div className="between-row" style={{ height: '40px' }} onClick={() => this.changeBuildRoom()}>
                <span style={{ color: '#434343', fontSize: '16px' }}>选择楼栋/床位号</span>
                <span  style={{ color: '#868686', fontSize: '13px' }}>{this.state.bed ? this.state.buildNames + ' >' + this.state.roomNames + ' >' + this.state.bed : '>'}</span>
              </div>
            )}
            {(this.detailInfo.property === '3') ? 
              <div className="timeBackground">
                <div className="time" onClick={() => this.onDateSelect.bind(this)()}>
                  <div>
                    <div className="top" style={{ color: '#434343', fontSize: '16px' }}>入住日期</div>
                    <div className="bottom">{this.state.startDate}</div>
                  </div>
                  <div className="info">
                    <div className="top" style={{ color: '#434343', fontSize: '16px' }}>离开日期</div>
                    <div className="bottom">{this.state.endDate}</div>
                  </div>
                </div>
              </div>
              : <div className="between-row" style={{ height: '40px' }}>
                <span style={{ color: '#434343', fontSize: '16px' }}>预定时间</span>
                <span style={{ color: '#868686', fontSize: '13px' }}>{this.state.startDate} ~ {this.state.endDate}</span>
              </div>
            }
            <Calendar
              {...this.state.config}
              visible={this.state.show}
              onCancel={this.onCancel}
              onConfirm={this.onConfirm}
              getDateExtra={this.getDateExtra}
              defaultDate={now}
              infiniteOpt = {true}
              minDate={new Date(+now)}
              // maxDate={new Date(+now + 31536000000)}
            />
          </div>
        </div>
      </div>
    )
  }
  // 选择工资划扣
  changePay() {
    this.setState({
      tab: 1,
      payType: 1,
      apply_reason: '',
      pay_type_department: '',
      freeType: '工资划扣',
      img: [],
    },()=>{
      sessionStorage.setItem('roomInfo', JSON.stringify({tab:'1'}))
    })
  }
  // 选择部门划转
  changeDepart() {
    this.setState({
      tab: 2,
      payType: 2,
      freeType: '部门划转'
    }, async ()=>{
      sessionStorage.setItem('roomInfo', JSON.stringify({tab:'2'}))
      const {data} = await employeeInfoApi({phone:cookie.get('sany_phone'),room_type:this.props.location.state&&this.props.location.state.roomId})
      // const {data} = await employeeInfoApi({phone:15868194226,room_type:this.props.location.state&&this.props.location.state.roomId})
      const res = (data)
      if (res.code === 'SUCCESS') {
        this.state.departmentList = res.data.department
      }
    })
  }
  // 付费方式
  payType() {
    return (
      <div className="component-body">
        <div className="dorm-info">
          <div className="dorm-info-title">
            <span style={{ color: '#333333', fontSize: '16px' }}>请选择扣费方式</span>
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{ height: '42px' }}>
              <Button style={{ width: '50%' }} onClick={this.changePay} className={this.state.tab === 1 ? 'payTypeactive' : 'payTypeTab'}>工资划扣</Button>
              <Button style={{ width: '50%' }} onClick={this.changeDepart} className={this.state.tab === 2 ? 'payTypeactive' : 'payTypeTab'}>部门划转</Button>
            </div>
            {this.state.payType === 2 ? this.department() : ''}
            {this.state.payType === 2 ? this.uploadImg() : ''}
          </div>
        </div>
      </div>
    )
  }
  textAreaChange(v: any) {
    this.setState({
      apply_reason: v
    })
  }
   // 是否显示部门
   department(){
    return(
      <div className="dorm-info-mid">
        <div className="between-row" style={{ height: '40px', margin:'10px 0' }}>
          <span style={{ color: '#434343', fontSize: '16px' }}>选择扣费部门</span>
          <span onClick={() => this.changeDepartment()} style={{ color: '#868686', fontSize: '14px' }}>{this.state.department + " >"}</span>
        </div>
      </div>
    )
  }
     // 获取部门
    async changeDepartment() {
      // const {data} = await employeeInfoApi({phone:'15221511724'})
      // const res = JSON.parse(data)
      let BUTTONS:any = []
      BUTTONS = this.state.departmentList
      const optionArr:any = []
      BUTTONS.forEach((v:any)=>{
        optionArr.push(v.name)
      })
      ActionSheet.showActionSheetWithOptions({
          options: optionArr,
          message: '请选择',
          maskClosable: true
        },
        (buttonIndex: number) => {
          if (buttonIndex >= 0 && buttonIndex < BUTTONS.length) {
            this.setState({
              department: BUTTONS[buttonIndex].name,
              departmentId: BUTTONS[buttonIndex].id,
            })
          }
        });
    }
  
  // 上传图片
  uploadImg() {
    const { files } = this.state;
    return (
      <div className="dorm-info-mid">
        <div style={{border: '1px solid #ccc',borderRadius:'3px'}}>
          <TextareaItem
            onChange={e => this.textAreaChange(e)}
            className="text-area"
            placeholder="请描述原因..."
            rows={3}
            count={150}
          />
            <ImagePicker
              files={files}
              onChange={this.onChangeUploadImg}
              onAddImageClick= {this.onAddImageClick}
              onImageClick={(index, fs) => console.log(index, fs)}
              selectable={files.length < 3}
            />
        </div>
      <div>
        {
          this.props.location.state.propertyTab === '3' ? 
          <p style={{ color: 'red', fontSize: '14px',marginTop:'10px' }}>您预订的房间级别超过公司规定/选择部门划转,需部门负责人审批通过后方可办理入住</p> 
          : 
          <p  style={{ color: 'red', fontSize: '14px',marginTop:'10px' }}>选择部门划转，需经部门负责人审批通过后，方可办理住宿</p>
        }
      </div>
    </div>
    )
  }
  // 提交预订按钮
  submitButton() {
    return (
      <Button className="submit-btn" onClick={() => this.submitClick()}>提交预订</Button>
    )
  }
  // 提交预订
  submitClick() {
    if(this.state.payType === 2 && !this.state.departmentId) {
      Toast.info('扣费部门必填')
      return
    }
    // if(!this.state.buildId) {
    //   Toast.info('楼栋必填')
    //   return
    // }
    // if(!this.state.roomId) {
    //   Toast.info('房间号必填')
    //   return
    // }
    // if(sessionStorage.getItem('reservationType') === 'changeBed' && !this.state.bedId) {
    //   Toast.info('床位必填')
    //   return
    // }
    // if(this.detailInfo.property_name==='员工宿舍' && sessionStorage.getItem('reservationType') === 'reservation' && !this.state.bedId ) {
    //   Toast.info('床位必填')
    //   return
    // }
    if (
      this.detailInfo.property_name === '员工宿舍' &&
      (sessionStorage.getItem('reservationType') === 'reservation' || sessionStorage.getItem('reservationType') === 'changeBed')
    ) {
      if (!this.state.buildId) {
        Toast.info('楼栋必填')
        return
      }
      if (!this.state.roomId) {
        Toast.info('房间号必填')
        return
      }
      if (!this.state.bedId) {
        Toast.info('床位必填')
        return
      }
    }
    if(!this.state.startDate || this.state.startDate === undefined) {
      Toast.info('入住日期必填')
      return
    }
    if(!this.state.endDate || this.state.endDate === undefined) {
      Toast.info('离开日期必填')
      return
    }
    const img:any = []
    this.state.files.forEach((v:any) => {
      img.push(v.url)
    })
    const obj = {
      id: 0, //预订管理id 如果是添加则传0 如果是编辑则传对应id
      store_id : this.detailInfo.storeId,
      room_property: this.userInfo.roomtype.property, // 入住性质 1：招待所 3：员工宿舍
      type : 1, // 是否为三一用户 1：是 2：否
      num: this.userInfo.num, // 工号
      phone: this.userInfo.phone, //手机号
      id_no: this.userInfo.id_no, //身份证
      building_no:this.state.buildNames,
      room_id: this.state.roomId , //房间id
      bed_id: this.state.bedId , //bed_id
      pay_type: this.state.payType, //付费方式 1： 工资划扣 2： 部门划转
      pay_type_department: this.state.departmentId || '', //如果选择2 则传划扣的部门id
      img: img, //图片数组
      apply_reason: this.state.apply_reason, //申请原因
      contacts: '', //联系人 非三一员工则此项需填（不是必填）
      contact_way: this.userInfo.phone, //联系方式 非三一员工则此项需填（必填）
      // checkin_day: this.state.startDay ? moment(this.state.startDay).format('yyyy-MM-DD') : undefined, //入住时间 （必填）
      // checkin_end_day:  this.state.endDay ? moment(this.state.endDay).format('yyyy-MM-DD') : undefined, //入住时间 （必填）
      checkin_day: this.state.startDate, //入住时间 （必填）
      checkin_end_day:  this.state.endDate, //入住时间 （必填）
      room_type: this.userInfo.roomtype.id, //房型
    }
    if (sessionStorage.getItem('reservationType') === 'changeBed') {
      const miss = {
        store_id:this.detailInfo.storeId,
        storeName: this.detailInfo.storeName,
        building_no:this.state.buildNames,
        room_no:this.state.roomNames,
        room_id:this.state.roomId,
        bed_no:this.state.bed,
        bed_id:this.state.bedId,
        room_property:this.userInfo.roomtype.property,
        room_property_name:this.detailInfo.property_name,
        roomTypeName:this.userInfo.roomtype.name,
        room_type:this.userInfo.roomtype.id,
        pay_type_name: this.userInfo.roomtype.property === '1' ? sessionStorage.getItem('changeDepartTypeName') : this.state.freeType,
        pay_type:this.userInfo.roomtype.property === '1' ? sessionStorage.getItem('changeDepartTypeId') : this.state.payType,
        pay_type_department_name: this.userInfo.roomtype.property === '1' ? sessionStorage.getItem('changePrimaryOrganizationName') : this.state.department, // 如果选择2 部门级别名称
        pay_type_department: this.userInfo.roomtype.property === '1' ? sessionStorage.getItem('changePayTypeDepartment') : this.state.departmentId, //如果选择2 则传划扣的部门id
        // checkin_day: this.state.startDay ? moment(this.state.startDay).format('yyyy-MM-DD') : undefined, //入住时间 （必填）
        // checkin_end_day: this.state.endDay ? moment(this.state.endDay).format('yyyy-MM-DD') : undefined, //入住时间 （必填）
        checkin_day: this.state.startDate, //入住时间 （必填）
        checkin_end_day: this.state.endDate, //入住时间 （必填）
        img: img,
        apply_reason: this.state.apply_reason, //申请原因
      }
      // 储存换床数据 到换床页展示
      sessionStorage.setItem('roomObj', JSON.stringify(miss)) //换房信息
      this.props.history.push({
        pathname: '/sany/change-bed',
        state: { type:'add' }, // 换房信息
      })
    } else {
      Toast.loading('加载中...')
      bookRoomAddApi({data:obj}).then((res:any)=>{
        Toast.hide()
        if(res.data.code === 'SUCCESS') {
          this.props.history.push({
            pathname: '/sany/booking-detail',
            state: { id: res.data.data.id }, // 预订单id
          })
        } else {
          Toast.info(res.data.msg)
        }
      })
    }
  }

  // 格式化时间
  formatDate(date: any) {
    /* eslint no-confusing-arrow: 0 */
    const pad = (n: number) => n < 10 ? `0${n}` : n;
    const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    return `${dateStr}`;
  }
  // 打开层级弹窗
  async changeBuildRoom() {
    this.setState({
      openBuildRoomList: true,
      structureValue1: [],
      structureValue2: [],
      structureValue3: [],
    })
    this.getBuildList(1)
  }
  async close() {
    this.setState({
      openBuildRoomList: false
    })
  }
  async sureBuildRoomName() {
    this.setState({
      openBuildRoomList: false
    })
  }
  // 获取楼栋数据
  async getBuildList(val: any) {
    Toast.loading('获取数据中...')
    const {data} = await buildingNoListApi({room_type:this.props.location.state&&this.props.location.state.roomId,phone:cookie.get('sany_phone')})
    // const {data} = await buildingNoListApi({room_type:this.props.location.state&&this.props.location.state.roomId,phone:15868194226})
    Toast.hide()
    if (data.code === 'SUCCESS' && data.data.length > 0) {
      this.setState({
        structureValue1: data.data,
        structureValue2: [],
        structureValue3: [],
        active1: '',
        active2: '',
        active3: '',
      })
    } else {

    }
  }
  // 获取房间数据
  async getRoomList(val: any) {
    this.setState({
      buildNames: val.name,
      buildId: val.id,
    })
    Toast.loading('获取数据中...')
    const {data} = await sanyRoomApi({room_type:this.props.location.state&&this.props.location.state.roomId,building_no: val.id,phone:cookie.get('sany_phone')})
    // const {data} = await sanyRoomApi({room_type:this.props.location.state&&this.props.location.state.roomId,building_no: val.id,phone:15868194226})
    Toast.hide()
    if (data.data.length < 1) {
      Toast.info('下一级暂无数据...')
    }
    if (data.code === 'SUCCESS') {
      this.setState({
        structureValue2: data.data,
        structureValue3: [],
        active1: val.id,
        active2: '',
        active3: '',
      })
    }
  }
  // 获取床位数据
  async getBedList(val: any) {
    this.setState({
      roomNames: val.name,
      roomId: val.id,
      active2: val.id,
    })
    if (this.detailInfo.property === '3' || sessionStorage.getItem('reservationType') === 'changeBed') {
      Toast.loading('获取数据中...')
      const {data} = await sanyBedListApi({room_id: val.id})
      Toast.hide()
      if (data.code === 'SUCCESS') {
        this.state.BedList = data.data
        this.setState({
          structureValue3: data.data,
          active2: val.id,
          active3: '',
        })
      }
    }
  }
  // 选择床位
  async getRList(val: any) {
    this.setState({
      bed: val.name,
      bedId: val.id,
      active3: val.id,
    })
  }
  // 选择房间和楼栋
  showBuildRoomList() {
    return (
      <div>
        <div className="selectgroup">
          <div className="head-top">
            <div className="color-grey" onClick={() => this.close()}>取消</div>
            <div></div>
            <div className="black-grey" onClick={() => this.sureBuildRoomName()}>确定</div>
          </div>
          <div className="selectList">
            <div className="selectPre1">
              <ul className="selectPreurl">
                <li className="color-grey" style={{margin:'.15rem 0'}}>楼栋</li>
                { this.state.structureValue1.map((item: any, value: any) => {
                  return (
                      <li
                        onClick={() => this.getRoomList(item)}
                        key={value}
                        style={{margin:'.15rem 0'}}
                        className={this.state.active1 == item.id ? 'active' : 'activeno' }
                      >{`${item.name}`}</li>
                  )
                } )
              }
              </ul>
            </div>
            {(this.state.structureValue2.length > 0 ?
              <div className="selectPre2">
               <ul className="selectPreurl">
                <li className="color-grey" style={{margin:'.15rem 0'}}>房间</li>
                 { this.state.structureValue2.map((item: any, value: any) => {
                   return (
                     <li
                       onClick={() => this.getBedList(item)}
                       key={value}
                       style={{margin:'.15rem 0'}}
                       className={this.state.active2 == item.id ? 'active' : 'activeno' }
                     >{`${item.name}`}</li>
                   )
                 } )
               }
               </ul>
             </div> : ''
            )}
            {(this.state.structureValue3.length > 0 ?
              <div className="selectPre3">
               <ul className="selectPreurl">
                <li className="color-grey" style={{margin:'.15rem 0'}}>床位</li>
                 { this.state.structureValue3.map((item: any, value: any) => {
                   return (
                     <li
                       onClick={() => this.getRList(item)}
                       key={value}
                       style={{margin:'.15rem 0'}}
                       className={this.state.active3 == item.id ? 'active' : 'activeno' }
                     >{`${item.name}`}</li>
                   )
                 } )
               }
               </ul>
             </div> : ''
            )}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      // <div className="book-info">
      <div className={phonePlatform() === 'iOS' ? 'book-info-hei' : 'book-info'}>
        <div className={this.state.openBuildRoomList ? 'coverLog' : ''}>
          {this.roomImg()}
          {this.joinRoom()}
          {this.userInfo&&this.userInfo.roomtype&&this.userInfo.roomtype.property === '1' && sessionStorage.getItem('reservationType') === 'changeBed' ? '' : this.payType() }
          {/* {this.state.payType === 2 ? this.uploadImg() : ''} */}
          {this.submitButton()}
        </div>
        {this.state.openBuildRoomList ? this.showBuildRoomList() : ''}
      </div>
    )
  }
}
